import React, { useEffect, useState } from "react";
import { Reply } from "./Reply";

const LIMIT = 2;

export const ReplyList = ({ replies, commentId, setEditMode }) => {
  const [replyList, setReplyList] = useState([]);
  const [skip, setSkip] = useState(0);

  // const updateReplyList = (newReply) => {
  //   if (replyList.length) {
  //     console.log("I CAME HERE", replyList.length);

  //     const idx = replyList.findIndex((reply) => reply.id === newReply.id);

  //     console.log(idx, replyList);

  //     const newReplyList = [...replyList];
  //     newReplyList[idx] = newReply;
  //     console.log("trying this");
  //     setReplyList(newReplyList);
  //   }
  // };

  useEffect(() => {
    const getData = () => {
      Promise.all(
        replies.slice(skip, skip + LIMIT).map((reply) => {
          return new Promise((resolve, reject) => {
            reply.onSnapshot((replyDoc) => {
              const data = replyDoc.data();

              if (replyDoc.exists) {
                data.user.get().then((userDoc) => {
                  const newReply = {
                    ...data,
                    id: replyDoc.id,
                    user: userDoc.data(),
                  };

                  resolve(newReply);
                });
              }
            });
          });
        })
      ).then((data) => {
        if (replyList.length < replies.length) {
          if (skip === 0) {
            setReplyList(data);
          } else {
            setReplyList([...replyList, ...data]);
          }
        } else if (replyList.length === replies.length) {
          setReplyList(replyList.filter((reply, i) => i < skip + LIMIT));
        }
      });
    };

    getData();
  }, [skip, replies]);

  if (!replies.length) {
    return <div />;
  }

  return (
    <div className="mb-2 pb-2">
      {replyList.map((reply) => (
        <Reply
          key={reply.id}
          reply={reply}
          commentId={commentId}
          setEditMode={setEditMode}
        />
      ))}
      {skip + LIMIT < replies.length && (
        <div className="w-full text-center mb-2">
          <button
            type="button"
            className="mx-auto text-gray-400 transition ease-in duration-200 text-center text-base underline hover:text-gray-300"
            onClick={(e) => setSkip(skip + LIMIT)}
          >
            Load More
          </button>
        </div>
      )}
      {skip + LIMIT >= replies.length &&
        replies.length !== 1 &&
        replies.length !== LIMIT && (
          <div className="w-full text-center mb-2">
            <button
              type="button"
              className="mx-auto text-gray-400 transition ease-in duration-200 text-center text-base underline hover:text-gray-300"
              onClick={(e) => setSkip(0)}
            >
              Collapse All
            </button>
          </div>
        )}
    </div>
  );
};
